export const isSameOrPastDate = (dateA: string, DateB: string): boolean => {
  // Parse the input date (assuming format DD/MM/YYYY) don't compare timezones and time
  const [day, month, year] = dateA.split('/').map(Number);
  const inputDate = new Date(year, month - 1, day);

  const date = new Date(DateB)
  const originalQuoteDateConverted = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  return inputDate <= originalQuoteDateConverted;
}
